module.exports = __webpack_public_path__ + "statics/img/01.b1f1743d.png";